import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">专题索引</h2>
          <p className="text-sm text-foreground-500">覆盖娱乐圈各大领域的爆料专题合集，一站直达你感兴趣的瓜田</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className={`group flex items-start gap-4 p-5 rounded-xl transition-colors cursor-pointer ${
                item.color === 'primary'
                  ? 'bg-background-50 hover:bg-primary-50'
                  : 'bg-background-50 hover:bg-accent-50'
              }`}
            >
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${
                  item.color === 'primary' ? 'bg-primary-100' : 'bg-accent-100'
                }`}
              >
                <i
                  className={`${item.icon} text-lg ${
                    item.color === 'primary' ? 'text-primary-600' : 'text-accent-600'
                  }`}
                ></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-1.5">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}